import { createFileRoute } from "@tanstack/react-router";
import { ServiceDetail } from "@/components/ServiceDetail";
import { serviceFaqs } from "@/data/serviceFaqs";
import img from "@/assets/network-rack-installation-denver.jpg.asset.json";
import { serviceGraph, abs } from "@/lib/serviceSchema";



export const Route = createFileRoute("/services/networking")({
  head: () => ({
    meta: [
      { title: "Home Network & Wi-Fi Install | Apex AV Denver" },
      { name: "description", content: "Enterprise-grade home network & Wi-Fi installation across Denver — engineered for streaming, gaming & smart homes. Free site survey." },
      { name: "keywords", content: "home network installation Denver, Wi-Fi installation Denver, mesh Wi-Fi Denver, enterprise home network Denver, network rack installation Denver, Cat6 wiring Denver, fiber installation Denver, access point installation Denver, structured cabling Denver, smart home network Denver, low voltage networking Denver" },
      { property: "og:title", content: "Networking & Wi-Fi — Apex AV Denver" },
      { property: "og:description", content: "Enterprise-grade networks built for luxury smart homes in Denver. Free site survey." },
      { property: "og:image", content: abs(img.url) },
      { name: "twitter:image", content: abs(img.url) },
      { property: "og:url", content: "https://apexav.com/services/networking" },
      { property: "og:type", content: "website" },
      { name: "twitter:title", content: "Networking & Wi-Fi — Apex AV Denver" },
      { name: "twitter:description", content: "Enterprise-grade networks built for luxury smart homes in Denver. Free site survey." },
    ],
    links: [{ rel: "canonical", href: "https://apexav.com/services/networking" }, { rel: "preload", as: "image", href: img.url, fetchPriority: "high" } as never],

    scripts: [
      {
        type: "application/ld+json",
        children: JSON.stringify(
          serviceGraph({
            slug: "networking",
            name: "Networking & Wi-Fi",
            description: "Enterprise-grade home networks engineered for streaming and smart devices in Denver.",
            pageTitle: "Home Network & Wi-Fi Install | Apex AV Denver",
            pageDescription: "Enterprise-grade home network & Wi-Fi installation across Denver — engineered for streaming, gaming & smart homes. Free site survey.",
            image: img.url,
            faqs: serviceFaqs["networking"],
            serviceType: "Networking & Wi-Fi",
            offerCatalog: [
              "Certified installer of leading enterprise network platforms",
              "High-performance access points with full-home heat-map survey",
              "Multi-gig fiber and high-bandwidth structured cabling",
              "VLAN segmentation for IoT, guest, and security devices",
              "Managed switches, firewalls, and remote monitoring",
              "Failover cellular backup for always-on connectivity",
            ],
            breadcrumbName: "Networking & Wi-Fi",
          })
        ),
      },
    ],
  }),
  component: () => (
    <ServiceDetail
      faqs={serviceFaqs["networking"]}
      topics={["networking", "av-installation", "smart-home", "prewire", "commercial"]}
      eyebrow="Networking"
      title="Wi-Fi that just works."
      intro={<>Enterprise-grade <strong>home network installation in Denver</strong> with high-performance <strong>Wi-Fi installation</strong>, access points, structured cabling, and low-latency support for dozens of smart devices.</>}
      image={img.url}
      imageAlt="Professional network rack installation with managed switches and AV gear in a Denver smart home"


      brands={["eero", "ubiquiti", "araknis", "wattbox"]}
      bullets={[
        "Certified installer of leading enterprise network platforms",
        "High-performance access points with full-home heat-map survey",
        "Multi-gig fiber and high-bandwidth structured cabling",
        "VLAN segmentation for IoT, guest, and security devices",
        "Managed switches, firewalls, and remote monitoring",
        "Failover cellular backup for always-on connectivity",
      ]}
      features={[
        { title: "Whole-home coverage", desc: "Engineered with a heat-map survey — no dead zones, no roaming drops." },
        { title: "Built for IoT", desc: "Smart devices isolated on their own VLAN — secure, organized, fast." },
        { title: "Remote-supported", desc: "We see issues before you do and resolve most remotely in minutes." },
      ]}
    />
  ),
});
